import React from 'react';
import { NavLink } from 'react-router-dom';
import { Grid, Typography, Link } from '@mui/material';

const UnavailableBanner = () => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: '100%',
        backgroundColor: '#cc1f36',
      }}
    >
      <Typography variant="h6" component="h6" sx={{ color: '#F3F3F3', textAlign: 'center' }}>
        Application Unavailable: Please refer to
        <Link
          component={NavLink}
          to="/help"
          target="help"
          rel="noopener noreferrer"
          sx={{
            color: '#F3F3F3',
            textDecoration: 'none',
            // Adding an underline on hover for better UX
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {' '}
          FAQ{' '}
        </Link>
        for how to submit paper form
      </Typography>
    </Grid>
  );
};

export default UnavailableBanner;